import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { MembershipProvider } from "./context/membershipContext";
//import * as Sentry from "@sentry/react";
import { Replay } from "@sentry/replay";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
//import { BrowserTracing } from "@sentry/tracing";
import TagManager from "react-gtm-module";
import ScrollToTop from "./components/ui/ScrollToTop";

//Original Code
// Sentry.init({
//   dsn: "https://faa70bfc57114de98e656cc0534ae2a0@o148073.ingest.sentry.io/5868776",
//   integrations: [new Integrations.BrowserTracing()],
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
//   tracesSampleRate: 1.0,
// });

//This actually works for tracing and replays
Sentry.init({
  dsn: "https://faa70bfc57114de98e656cc0534ae2a0@o148073.ingest.sentry.io/5868776",
  integrations: [
    new Integrations.BrowserTracing(),
    new Replay({
      maskAllText: true,
      blockAllMedia: true,    
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
  // We recommend adjusting this value in production.
  tracesSampleRate: 1.0,
  // Adjust Replay sampling rate as needed
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


//This does not work
// Sentry.init({
//   dsn: "https://faa70bfc57114de98e656cc0534ae2a0@o148073.ingest.sentry.io/5868776",

//   integrations: [
//     Sentry.replayIntegration({
//       // Additional SDK configuration goes in here, for example:
//       maskAllText: true,
//       blockAllMedia: true,
//     }),  ],

//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

//This does not work
// Sentry.init({
//   dsn: "https://faa70bfc57114de98e656cc0534ae2a0@o148073.ingest.sentry.io/5868776",
//   integrations: [
//     new Replay({
//       // Additional SDK configuration goes in here, for example:
//       maskAllText: true,
//       blockAllMedia: true,
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
//   // We recommend adjusting this value in production.
//   tracesSampleRate: 1.0,
//   // Adjust Replay sampling rate as needed
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

// Sentry.init({
//   dsn: "https://faa70bfc57114de98e656cc0534ae2a0@o148073.ingest.sentry.io/5868776",
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
//   integrations: [Sentry.replayIntegration({
//     // Additional SDK configuration goes in here, for example:
//     maskAllText: true,
//     blockAllMedia: true,
//     }), new Integrations.BrowserTracing()] 
// });

const tagManagerArgs = {
  gtmId: "GTM-PJS6XZZ",
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MembershipProvider>
        <ScrollToTop />
        <App />
      </MembershipProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
